import { Component } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { Product } from 'src/app/models/Product';
import { customFormFields } from 'src/app/models/customFormFields';
import { AdminProdcutService } from 'src/app/service/admin-product-service';
import { UtilityService } from 'src/app/service/utility.service';


@Component({
  selector: 'app-admin-product-listing',
  templateUrl: './admin-product-listing.component.html',
  styleUrls: ['./admin-product-listing.component.css'],
})
export class AdminProductListingComponent {
  title1 = 'Admin Panel';
  title = 'Product Listing';

  products: Product[] = [];
  totalProducts: number = 0;
  pageLimit: number = 10;
  filters: any = {};

  //Filter lists
  categories: any[] = [];
  productType: any[] = [];
  productStatus: any[] = [];

  search: string = "";

  filterForm: FormGroup;

  formFields: customFormFields[] =
    [
      { control: 'productCategoryId', validators: [Validators.required] },
      { control: 'productTypeId', validators: [Validators.required] },
      { control: 'validationStatusId', validators: [Validators.required] },
      { control: 'publishedAt', validators: [Validators.required] },
    ];
  newArray: string[] = this.formFields.map(obj => obj.control);
  constructor(private productService: AdminProdcutService, private utility: UtilityService) {
    this.getProductListing();
    this.loadAllFilters();
    this.filterForm = this.utility.creatFormGroup(this.formFields);
  }


  filter() {
    this.search = "";
    this.addOrRemove();
    this.getProductListing();
  }

  reset() {
    this.search = "";
    this.restForm();
    this.addOrRemove()
    this.getProductListing();
  }

  addOrRemove() {
    this.newArray.forEach(value => {
      let formValues = this.filterForm.value;
      if (formValues[value] && formValues[value] > 0) {
        this.filters[value] = formValues[value];
      } else {
        if (this.filters[value]) delete this.filters[value]
      }
    })
  }

  restForm() {
    this.utility.customResetFormGroup(this.filterForm, this.newArray);
  }

  async loadAllFilters() {
    this.categories = await this.getMasters("prodCategory");
    this.productType = await this.getMasters("prodType");
    this.productStatus = await this.getMasters("prodStatus");
  }

  async getMasters(name: string): Promise<any[]> {
    try {
      const master = await this.productService.getMasters(name);
      if (master['status'] === 'SUCCESS')
        return master.data;
      else
        return [];
    } catch (error) {
      return [];
    }
  }

  getProductListing() {
    this.filters["start"] = this.currentPage;
    this.filters["size"] = this.pageLimit;
  console.log("filters", this.filters)
  this.loading = true;
    let queryParams = this.utility.objectToQueryParams(this.filters)
    this.productService.getProductListing(queryParams).then((data: any) => {
      this.loading = false;
      if (data.status == "SUCCESS") {
        this.products = data.records as Product[];
        this.totalRecords = data.totalRecords as number;
      }
    })
  }

  modify(product: Product, event: string) {
    switch (event) {
      case "EDIT":
       this.handleEditProduct(product.productId);
        return;
      case "VIEW":
        console.log("VIEW event is called ")
        return;
      default:
        console.log("edit event is called ")
        return;
    }
  };


  title2 = 'Add new Product';
  title3 = 'Seller Name';
  class1 = "profile-banner"
  productDetailsTitle = "Product details"
  currentPage: number = 1;
  pageSearch: string = '';
  totalRecords: number = 1;
  loading: boolean = true;
  showAddProductCard: boolean = false;
  showEditProductCard: number = 0;
  addProductForm: any = FormGroup;

  shopifyLink: string = "";
  lastSynched: string = "";
  description: string = "";
  showDescription: boolean = false;
  showUpdateProductCard: number = 0;
  searchProduct: string = "";
  productDetails: any = {
    loading: false,
    response: null,
    error: ''
  }
  showDetails: boolean = false;



  ngOnInit() {
  }

  onPageChange(page: any) {
    this.currentPage = page;
    this.getProductListing();
  }

  resetListing(){
    this.showAddProductCard = false;
    console.log('here')
    this.currentPage = 1;
    this.getProductListing();
  }

  resetEditListing(){
    this.showEditProductCard = 0;
    console.log('here')
    this.getProductListing();
  }
  onPageSizeChange(page: any) {
    this.pageLimit = page;
    this.currentPage = 1;
    this.getProductListing();
  }


  handleProductUpdate(){
    if(this.showUpdateProductCard){
      this.productService.deleteProduct(this.showUpdateProductCard).then(()=>{
        this.currentPage = 1;
        this.getProductListing();
        this.showUpdateProductCard = 0;
      })
    }
  }

  showProductDescription(des: string) {
    this.description = des;
    this.showDescription = true;
  }


  searchProductOnChange(value: any) {
    if (value.target.value) {
      this.searchProduct = value.target.value;
      this.filters["search"] =  this.searchProduct;
    }
    else {
      this.searchProduct = "";
      this.filters["search"] =  this.searchProduct;
    }

    this.getProductListing();
  }

  addProductToFavorites(productVariantId: number, type: number) {
    const favType = type == 0 ? 1 : 0
    this.productService.addProductToFavorites(productVariantId, favType).then((res: any) => {
      this.getProductListing();
    }).catch((err: any) => { })
  }


  // getProductList() {
  //   this.productService.getProductListing(this.searchProduct, this.currentPage, this.pageLimit).then((res: any) => {
  //     this.products = res.data.records;
  //     this.lastSynched = res.data.lastSynched ?? "";
  //     this.shopifyLink = res.data.shopifyStoreLink ?? "";
  //     this.totalRecords = res.data?.totalRecords;
  //     this.loading = false;
  //     // this.currentPage = 1;
  //   }).catch((err: any) => {
  //     this.loading = false;
  //     this.products = [];
  //   })
  // }

  showProductDetails(id: number) {
    this.showDetails = true;
    this.productDetails = {
      ...this.productDetails,
      loading: true,
      error: ''
    }
    this.productService.getProductById(id).then((res: any) => {
      this.productDetails = {
        ...this.productDetails,
        loading: false,
        response: res.data.data,
      }
    }).catch((err: any) => {
      this.productDetails = {
        ...this.productDetails,
        loading: false,
        response: null,
        error: err.response.statusText
      }
      console.log(this.productDetails,'ddddd')
    })
  }


  getProductShortDescription(des: any) {
    return false
    if (des && des.length > 40) {
      return true;
    }
    else {
      return false;
    }
  }

  handleAddProduct(status:boolean){
    this.showAddProductCard = status;
  }
  handleEditProduct(productId:number){
    this.showEditProductCard = productId;
  }

  handleUpdateProduct(productId:number){
    this.showUpdateProductCard = productId;
  }



  createNewProduct() { }
}
